<div>
  <div class="sub-heading mt-0">
    <span *ngIf="annotationContent == null">{{addAnnotationLabel}}</span>
    <span *ngIf="annotationContent != null">{{editAnnotationLabel}}</span>
  </div>
  <div class="mx-2-5 mb-3-5">
    <div class="my-1 right-panel-label-color" tabindex="0">
      {{annotatingLabel}}
    </div>
    <app-location-breadcrumb></app-location-breadcrumb>
  </div>
  <div class="mx-2-5 mb-3-5">
    <form [formGroup]="annotationForm">
      <mat-form-field class="mb-1 width-100">
        <mat-label class="textBox-text">{{annotationTitleOptionalLabel}}</mat-label>
        <input appAutoFocus class="textBox-text" matInput placeholder="" formControlName="annotationTitle" type="text" maxlength="100">
      </mat-form-field>

      <mat-form-field class="width-100 mt_1">
        <mat-label class="textBox-text">{{yourAnnotationLabel}}</mat-label>
        <div class="textarea-wrapper flex-display">
          <textarea class="textBox-text textarea-padding" type="text" matInput cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="6" (input)="annotationDescriptionChange($event.target.value)"
                    [formControl]="annotationDescriptionFormControl" formControlName="annotationContent" maxlength="4000" (keyup)="keyenter()"></textarea>
          <div class="remaning">{{remainingText}}/4000</div>
        </div>
      </mat-form-field>
      <mat-error class="mat-field-hint mb-1 " *ngIf="textareaError != ''"> {{textareaError}}</mat-error>
    </form>

    <div class="flex-display pt-1">
      <button mat-button class="btn-secondary-action-close" (click)="closeOverlayButton()" (keyup.enter)="closeOverlayButton()" tabindex="0">{{cancelButtonLabel}}</button>
      <button mat-button class="btn-primary-action-add" (click)="addAnnotation()" (keyup.enter)="addAnnotation()" tabindex="0">
        <span *ngIf="annotationContent == null">{{addButtonLabel}}</span>
        <span *ngIf="annotationContent != null">{{editButtonLabel}}</span>
      </button>
    </div>
  </div>
</div>
